import React from "react";
import {Col, Row, Tabs} from "antd";
import {type TabsProps} from "antd";

import AccountDetailsCard from "../../../components/account/AccountDetailsCard";
import AccountAdditionalDetails from "../../../components/account/AccountAdditionalDetails";
import ErrorBoundary from "../../../components/ErrorBoundary";
import AccountClose from "./AccountClose";
import PageTitle from "../../../components/page/PageTitle";
import {cardsGridColumn} from "../../../assets/styles";
import {UserOutlined} from "@ant-design/icons";

const AccountInfo = () => {

    const tabsItems: TabsProps['items'] = [
        {
            label: 'General Information',
            key: '1',
            children:
                <ErrorBoundary>
                    <Row gutter={{sm: 16}}>
                        <Col {...cardsGridColumn}>
                            <AccountDetailsCard />
                        </Col>
                        <Col {...cardsGridColumn}>
                            <AccountAdditionalDetails />
                        </Col>
                    </Row>
                </ErrorBoundary>
        },
        {
            label: 'Account Closure',
            key: '2',
            children: <AccountClose />
        }
    ];

    return (
        <>
            <PageTitle title="Account Info" icon={<UserOutlined/>}/>
            <Tabs defaultActiveKey="1" items={tabsItems} />
        </>
    )
}

export default AccountInfo;
